import { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  GoogleOAuthProvider,
  GoogleLogin,
  CredentialResponse,
} from "@react-oauth/google";

import { getDays, getIsLoading } from "../../core/dates/selectors";
import { getIsConfigLoading, getConfigData } from "../../core/config/selectors";
import { getIsLoggedIn } from "../../core/auth/selectors";
// import { DATES_SELECT_DAY } from '../../core/dates/action-types';
import { login } from "../../core/auth/actions";
import { useAppDispatch } from "../../core/hooks";
import { fetchConfig } from "../../core/config/actions";
import { fetchDates } from "../../core/dates/actions";
import { Controls, Header, Month } from "..";

import "./style.css";

export const Calendar = () => {
  const dates = useSelector(getDays);
  const loggedIn = useSelector(getIsLoggedIn);
  const loading = useSelector(getIsLoading);
  const configLoading = useSelector(getIsConfigLoading);

  const configData = useSelector(getConfigData);

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchConfig()).then(() => {
      if (loggedIn) {
        dispatch(fetchDates());
      }
    });
  }, [dispatch]);

  const responseGoogle = useCallback(
    (payload: CredentialResponse) => dispatch(login(payload)),
    [dispatch]
  );

  return (
    <GoogleOAuthProvider clientId={configData.google_account ?? ""}>
      <Header />
      <div className="container">
        {loading || configLoading ? (
          <div className="loader"></div>
        ) : loggedIn ? (
          <div className="months">
            {dates.map((month) => (
              <Month key={month} month={month} />
            ))}
          </div>
        ) : (
          <div className="welcome">
            <p>Welcome to the new trackmyholidays.com</p>
            <p>
              Here your can track you holidays in one yearly view, making it
              easy to see how many days you have left to plan
            </p>
            <p>
              Please log in with your google account, so we can sync your
              holidays and allow you to access them on any device
            </p>
            {configData.google_account && (
              <div className="button">
                <GoogleLogin auto_select onSuccess={responseGoogle} />
              </div>
            )}
          </div>
        )}
      </div>
      <Controls />
    </GoogleOAuthProvider>
  );
};
